export { LinkAvatar as Avatar } from "./linkAvatar";
export { LinkNavigation as Navigation } from "./linkNavigation";
export { LinkShop as Shop } from "./linkShop";
export { LinkSkip as Skip } from "./linkSkip";



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/link/link.ts
// module id = mFZ8
// module chunks = 2